import './App.css';
import VendingMachine from "./components/VendingMachine";

function App() {
  return (
    <VendingMachine />
  );
}

export default App;
